// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionExplainerButtons')

function TopCallToActionExplainerButtons(props) {
  return tag('div', {
    className: bem.block()
  },
    tag('button', {
      className: bem.element('button', 'primary'),
      onClick: props.onPrimaryClick
    },
      `Join Mix`
    ),
    props.onSecondaryClick && tag('button', {
      className: bem.element('button', 'secondary'),
      onClick: props.onSecondaryClick
    },
      `Sign in`
    )
  )
}

TopCallToActionExplainerButtons.propTypes = {
  // Callbacks
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func
}

module.exports = TopCallToActionExplainerButtons
